export const slideshow = [
  {
    video: "https://sudoart.s3.us-east-2.amazonaws.com/sudowrite/pricing/brainstorm-recording.m4v",
    duration: 5766,
    text: "Get started easily with Brainstorm",
  },
  {
    video: "https://sudoart.s3.us-east-2.amazonaws.com/sudowrite/pricing/expand-with-zoom-v4.m4v",
    duration: 9766,
    text: "Go from outline to rough draft with Expand",
  },
  {
    video: "https://sudoart.s3.us-east-2.amazonaws.com/sudowrite/pricing/wormhole-with-zoom-v4.m4v",
    duration: 8033,
    text: "Bust through writer's block with Write",
  },
  {
    video: "https://sudoart.s3.us-east-2.amazonaws.com/sudowrite/pricing/rewrite-with-zoom-v4.m4v",
    duration: 18600,
    text: "Get through tricky dialogue with Rewrite",
  },
];

export const tileGrid = [
  {
    image: "/assets/pricing/wormhole-banished.png",
    text: "Writer's block - Banished!",
  },
  {
    image: "/assets/pricing/brainstorm-thumb.png",
    text: "An always-available brainstorm buddy",
  },
  {
    aboveText: 'Alternates for "ripple"',
    image: "/assets/pricing/meager.png",
    text: "Skip the trip to thesaurus.com",
  },
  {
    image: "/assets/pricing/feature-guided-write.png",
    text: "Our AI follows instructions",
  },
  {
    image: "/assets/pricing/feedback-button.png",
    text: "Beta feedback without having to find beta readers",
  },
  {
    image: "/assets/pricing/rewrite-icon.svg",
    text: "Rephrase tricky dialogue",
  },
  {
    image: "/assets/pricing/rewrite-button.png",
    text: '"Plus it" or "Show, don\'t tell" with ease',
  },
  {
    text: "Speaks 30+ languages",
    overlayImage: "/assets/pricing/multilingual.png",
  },
  { text: "Does your laundry for you" },
  {
    image: "/assets/pricing/character-icon.svg",
    text: "Generate new characters",
  },
  {
    image: "/assets/pricing/brainstorm-button.png",
    text: "Getting started? Easy",
  },
];
